ACC.orderReason = {
  systemnumber: '#systemnumber',
  orderReasonId: '#orderReason',
  iplookupClass: 'ph-ipLookupImpl',
  orderItems: '.ph-orderitem',
  sixnc: '#sixnc',
  iPserialnumber: '#iPserialnumber',
  systemdescription: '#systemdescription',
  sixncReg: /^[\d]{6,12}$/,
  sysNumReg: /^[A-Za-z0-9]+$/,
  contractNumber: '#sapContractNumber',
  spinnerOrder: '.ph-spinnerorder',
  errorContract: '.ph-errorforContract',
  successContract: '.ph-sucessforContract',
  equipmentiPserialnumberIds: '#equipmentserialnumber,#iPserialnumber,#validEquipmentNumber',
  iPsection: '.ph-installedProduct-Section',
  equipmentserialnumberId: '#equipmentserialnumber',
  $isssoLogin: $('.ph-sso-seession').html(),
  entitlementbody: '.ph-entitlement__body',
  defaultloader: '.ph-loader__default',
  displayblock: 'ph-d-block',
  displaynone: 'ph-d-none',
  ipandentitlement: '.ph-ipandentitlement',
  entitlement: '.ph-entitlement',
  orderreasonpage: '.ph-orderreasonpage',
  spcontractRadio: '.serviceplancontract__radio',
  showCoverageDetails: $('.ph-showCoverageDetails').text(),
  entitlementError: '.ph-entitlement_error',

  bindAll: function() {
    this.uploadDocument();

    this.fileUploadClick();
    this.bindDropdownChanges();
    this.bindOrderReasonBtn();
    $(document).on('blur', '.ph-input-parent .ph-forminput', function() {
      if ($(this).val() === '') {
        ACC.orderReason.setErrorFlag($(this), true);
      } else {
        ACC.orderReason.clearErrorFlag($(this), true);
      }
    });
    $(document).on('blur', '#incidentNumber', function() {
      ACC.orderReason.checkIncident();
    });
  },
  setErrorFlag: function(item) {
    var itemParent = item.closest('.ph-inputData');

    if (itemParent.find('.form_field_error').length === 0) {
      item.closest('.ph-signup__error').addClass('form_field_error');
      item.closest('.ph-signup__error').find('.ph-register__emptyvalue').text(itemParent.attr('data-emptyContent'));
      item.closest('.ph-signup__error').find('.ph-register__emptyvalue').addClass('ph-text-danger');
    }
  },
  clearErrorFlag: function(item) {
    var itemParent = item.closest('.ph-inputData');

    if (itemParent.find('.form_field_error').length > 0) {
      item.closest('.ph-signup__error').removeClass('form_field_error');
      item.closest('.ph-signup__error').find('.ph-register__emptyvalue').text('');
    }
  },
  validateDropdown: function(selectElement) {
    var setFlag = true,
        elementVal = selectElement.val(),
        elementParent = selectElement.parents('.ph-inputData'),
        elementSubParent = selectElement.parents('.ph-signup__error'),
        elementErrorSpan = elementParent.find('.ph-register__emptyvalue'),
        elementErrorMsg = elementParent.attr('data-emptycontent');

    if (elementVal === '') {
      if (elementParent.find('.form_field_error').length === 0) {
        elementSubParent.wrapAll('<span class="form_field_error ph-form_field_error"></span>');
        elementErrorSpan.text(elementErrorMsg);
      }

      setFlag = false;
    } else if (elementParent.find('.form_field_error').length > 0) {
      elementSubParent.unwrap();
      elementErrorSpan.text('');
    }

    return setFlag;
  },
  daysDropdownChange: function() {
    var itemVal = $('#numberofdays').val();

    $('.otherdaystool').addClass('hidden').next().removeClass('clear-both');

    if (itemVal === 'other') {
      $('.otherdaystool').removeClass('hidden').next().addClass('clear-both');
    } else if (itemVal !== '') {
      $('#otherdays').val(itemVal);
    }
  },
  toggleContAltMessage: function(selectedClass) {
    $('.ph-tibacontractaltmessage, .ph-pcmscontractaltmessage, .ph-indentcontractaltmessage').addClass('hidden');

    if (selectedClass === 'tibaservicecontract') {
      $('.ph-tibacontractaltmessage').removeClass('hidden');
    } else if (selectedClass === 'pmscscontract') {
      $('.ph-pcmscontractaltmessage').removeClass('hidden');
    } else if (selectedClass === 'indentcontract') {
      $('.ph-indentcontractaltmessage').removeClass('hidden');
    }
  },
  orderReasonDropdownChange: function() {
    var selectedClass = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();


    $('.ph-orderTypeValue').text($(ACC.orderReason.orderReasonId).val());
    $(ACC.orderReason.iPserialnumber).parents(ACC.orderReason.orderItems).find('.ph-formlabel .optional').hide();
    $(ACC.orderReason.equipmentserialnumberId).parents(ACC.orderReason.orderItems).find('.ph-iplookup').show();

    $(ACC.orderReason.orderItems).hide();

    if (selectedClass) {
      $('.' + selectedClass).show();
    }

    ACC.orderReason.toggleContAltMessage(selectedClass);

    if (selectedClass === 'toolrental') {
      ACC.orderReason.daysDropdownChange();
    } else {
      $('.otherdaystool').addClass('hidden').next().removeClass('clear-both');
    }

    if (selectedClass === 'tibaservicecontract') {
      $(ACC.orderReason.iPserialnumber).parents(ACC.orderReason.orderItems).find('.ph-formlabel .optional').show();
      $('.ph-tibaservicecontract').removeClass('hidden');
    } else if (selectedClass === 'pmscscontract' || selectedClass === 'indentcontract') {
      $('.ph-cmscontract').removeClass('hidden');
    } else if (selectedClass === 'commercialdefoa') {
      $(ACC.orderReason.equipmentserialnumberId).parents(ACC.orderReason.orderItems).find('.ph-iplookup').hide();
    } else if (selectedClass === 'equipmentwarranty') {
      $('.ph-orderfield').each(function() {
        var itemOrder = $(this).attr('data-order');

        if (itemOrder !== '') {
          $(this).css('order', $(this).attr('data-order'));
        }
      });
    } else {
      $('.ph-orderfield').css('order', '');
    }

    ACC.orderReason.orderReasonDropdownChangeone(selectedClass);
  },
  orderReasonDropdownChangeone: function(selectedClass) {
    ACC.orderReason.iplookupfeaturetoogle(selectedClass);
    $('.ph-cmscontract').addClass('hidden');
    $('.ph-tibaservicecontract').addClass('hidden');
  },

  iplookupfeaturetoogle: function(selectedClass) {
    if (selectedClass === 'billed' && ACC.orderReason.$isssoLogin !== 'true') {
      ACC.orderReason.iplookupfeaturetoogleImple();
    }

    if (selectedClass === 'equipmentwarranty' || selectedClass === 'commercialdefoa') {
      ACC.orderReason.iplookupfeaturetoogleImple();
      ACC.orderReason.iplookupforEquipmentSection();
    }

    if (selectedClass === 'pmscscontract' ||
      selectedClass === 'tibaservicecontract' || selectedClass === 'indentcontract') {
      ACC.orderReason.iplookupfeaturetoogleImple();
      ACC.orderReason.iplookupcontractNumber();
    }
  },
  iplookupfeaturetoogleImple: function() {
    $(ACC.orderReason.iPsection).removeClass('hidden');
    $(ACC.orderReason.systemdescription).parents(ACC.orderReason.orderItems).addClass(ACC.orderReason.iplookupClass);
    $(ACC.orderReason.sixnc).parents(ACC.orderReason.orderItems).addClass(ACC.orderReason.iplookupClass);
    $(ACC.orderReason.systemnumber).parents(ACC.orderReason.orderItems).addClass(ACC.orderReason.iplookupClass);
  },
  iplookupcontractNumber: function() {
    $('#contractNumber').removeClass('hidden');
  },
  iplookupforEquipmentSection: function() {
    $('#forEquipmentSection').removeClass('hidden');
  },
  iplookupfeaturetoogleReset: function() {
    $(ACC.orderReason.iPsection).addClass('hidden');
    $(ACC.orderReason.systemdescription).parents(ACC.orderReason.orderItems).removeClass(ACC.orderReason.iplookupClass);
    $(ACC.orderReason.sixnc).parents(ACC.orderReason.orderItems).removeClass(ACC.orderReason.iplookupClass);
    $(ACC.orderReason.systemnumber).parents(ACC.orderReason.orderItems).removeClass(ACC.orderReason.iplookupClass);
    $('#contractNumber').addClass('hidden');
    $('#forEquipmentSection').addClass('hidden');
  },
  uploadDocument: function() {
    $('input[name="getSpFile"]').change(function() {
      var file = $('#getSpFile')[0].files[0].name;

      $('.ph-importorderparent__choosetext').html(file);
    });
  },
  fileUploadClick: function() {
    $('#browseSPFile').on('click', function() {
      $('input[name="getSpFile"]').trigger('click');
    });
    $('#uploadSPFile').on('click', function() {
      var obj = {},
          resetMsg = $('.ph-filebrowsetext').attr('data-default');

      obj.formData = new FormData(document.getElementById('SPSOrderReasonForm'));
      obj.path = $('#uploadSPFile').attr('data-uploadUrl');
      obj.fId = '#getSpFile';
      obj.resetMsg = resetMsg;
      ACC.placeorder.uplodDocButton(obj);
    });
  },
  getFileChange: function(e) {
    var file = e.files[0].name;

    $('.ph-filebrowsetext').html(file).attr('title', file);
  },
  bindDropdownChanges: function() {
    // Dropdown change function
    $('#numberofdays').on('change', function() {
      ACC.orderReason.daysDropdownChange();
    });

    var currentOrderReason = $(ACC.orderReason.orderReasonId).val();

    $(ACC.orderReason.orderReasonId).on('change', function() {
      ACC.orderReason.iplookupfeaturetoogleReset();
      ACC.orderReason.orderReasonDropdownChange();
      ACC.orderReason.mobileViewOrderReason();

      if (currentOrderReason !== $(this).val()) {
        $(ACC.orderReason.entitlementbody).addClass('hidden');
        $(ACC.orderReason.entitlementError).addClass('hidden');
      }

      if (ACC.orderReason.$isssoLogin === 'true' && currentOrderReason !== $(this).val()) {
        ACC.orderReason.checkIpLookupnewSenarios();
      }

      currentOrderReason = $(this).val();

      ACC.orderReason.checkorderreason();
    });
  },
  checkIncident: function() {
    var result = true;

    if ($('#incidentNumber').val() === '') {
      ACC.orderReason.clearErrorFlag($('#incidentNumber'), false);
    } else if ($.isNumeric($('#incidentNumber').val())) {
      ACC.orderReason.clearErrorFlag($('#incidentNumber'), false);
    } else {
      ACC.orderReason.setErrorFlag($('#incidentNumber'), false);
      result = false;
    }

    return result;
  },
  showPopup: function(ipNumberZero, contractSectionVisible, contractSelected) {
    var showPopup = false,
        orderReasonSelected = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    if ((ipNumberZero === true) && (contractSectionVisible === false || contractSelected === false)) {
      showPopup = true;
    }

    if (orderReasonSelected === 'commercialdefoa' || orderReasonSelected === 'billed') {
      showPopup = false;
    }

    if (showPopup === true) {
      ACC.orderReason.orderReasonPopup(orderReasonSelected, contractSectionVisible);
    } else {
      ACC.orderReason.orderReasonBtnValidations();
    }
  },
  checkPopupConditions: function() {
    var $ipSection = $(ACC.orderReason.iPsection),
        ipSectionVisible = $ipSection.is(':visible'),
        ipNumberZero = false,
        $contractSection = $('#sapContractNumber'),
        contractSectionVisible = $contractSection.is(':visible'),
        contractSelected = false,
        ipSerialNumber = '',
        equipmentserialNum = '';

    if (ipSectionVisible === true) {
      ipSerialNumber = $ipSection.find(ACC.orderReason.iPserialnumber);
      equipmentserialNum = $ipSection.find(ACC.orderReason.equipmentserialnumberId);

      if ((ipSerialNumber.is(':visible') && ipSerialNumber.val() === '0') || (equipmentserialNum.is(':visible') && equipmentserialNum.val() === '0')) {
        ipNumberZero = true;
      }
    }

    if (contractSectionVisible === true && $('input[name="servicecontractnum"]').is(':checked') === true) {
      contractSelected = true;
    }

    if (ipSectionVisible === true) {
      ACC.orderReason.showPopup(ipNumberZero, contractSectionVisible, contractSelected);
    } else {
      ACC.orderReason.orderReasonBtnValidations();
    }
  },
  orderReasonPopup: function(orderReasonSelected, contractSectionVisible) {
    var popupWidth = '100%';

    if ($(window).width() < 768) {
      popupWidth = '90%';
    }

    $('.ORPopupOkBtn').click(function() {
      $.colorbox.close();
      ACC.orderReason.orderReasonBtnValidations();
    });
    $('.ORPopupCancelBtn').click(function() {
      if ($(ACC.orderReason.iPsection).find(ACC.orderReason.iPserialnumber).is(':visible')) {
        ACC.orderReason.setErrorFlag($('#iPserialnumber'));
      } else {
        ACC.orderReason.setErrorFlag($('#equipmentserialnumber'));
      }

      if (contractSectionVisible && $('#sapContractNumber').val() === '') {
        ACC.orderReason.errorMessageHandler(ACC.orderReason.errorContract, 'text.orderReasonPage.contractnumber.error');
      }

      $.colorbox.close();
      ACC.orderReason.scrollTillError();
    });

    if (orderReasonSelected === 'tibaservicecontract') {
      $('.ORPopup_nocontractTitle').addClass('hidden');
      $('.ORPopup_contractTitle').removeClass('hidden');
    } else {
      $('.ORPopup_nocontractTitle').removeClass('hidden');
      $('.ORPopup_contractTitle').addClass('hidden');
    }

    $.colorbox({
      inline: true,
      href: '#orderReasonPopup',
      scrolling: false,
      height: 'auto',
      width: popupWidth,
      maxWidth: 400,
      overlayClose: true,
      fixed: true,
      close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('#colorbox').css('border-radius', '3px');
      }
    });
  },
  orderReasonBtnValidations: function() {
    var itemFlag = ACC.orderReason.validateDropdown($(ACC.orderReason.orderReasonId)),
        $orderReason = $('#orderReason option:selected').attr('data-smallValue'),
        $numberofdays = $('#numberofdays').val();

    if (itemFlag) {
      if ($orderReason === 'toolrental') {
        itemFlag = ACC.orderReason.validateDropdown($('#numberofdays'));

        if (itemFlag && $numberofdays === 'other') {
          itemFlag = ACC.orderReason.validateDropdown($('#otherdays'));
        }
      }

      if (itemFlag) {
        itemFlag = ACC.orderReason.checkIncident();
      }

      if (itemFlag) {
        $('#orderReasonSub').click();
        $(ACC.orderReason.defaultloader).show();

        ACC.omniture.bindTrackConversion('interaction', 'order_type:' + $orderReason);
      }
    }
  },
  bindOrderReasonBtn: function() {
    $(document).on('click', '#orderReasonBtn', function() {
      ACC.orderReason.checkPopupConditions();
      ACC.orderReason.scrollTillError();
    });
  },
  uploadedFileName: function() {
    var imageName = $('#orderReasonBackendValues').attr('data-imageName');

    if (imageName !== '') {
      $('.ph-filebrowsetext').text(imageName).attr('title', imageName);
    }
  },
  getOrderReasonArray: function() {
    var data = [];

    $('#orderReason option:not(:disabled)').each(function() {
      var smallValue = $(this).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

      $(this).attr('data-smallValue', smallValue);
      data.push(smallValue);
    });

    return data;
  },
  ipLookuperrorHandler: function(errorIp, msgType) {
    switch (msgType) {
        case 'text.iplookup.error':
          $(errorIp).html($(errorIp).attr('ipLookupError'));

          break;
        case 'text.iplookup.refinesearch':
          $(errorIp).html($(errorIp).attr('ipLookuprefinesearch'));

          break;
        case 'text.iplookup.noresults':
          $(errorIp).html($(errorIp).attr('noresults'));

          break;
        case 'text.iplookup.embargo':
          $(errorIp).html($(errorIp).attr('iplookupembargo'));

          break;
        default:
    }

    $(errorIp).removeClass('hidden');
    $(errorIp).addClass('form_field_error');
  },
  isCourageAllowed: function() {
    var orderReasontype = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    if (ACC.orderReason.showCoverageDetails === 'true' &&
     $('.ph-coverageOrderReason').html().indexOf(orderReasontype) >= 0) {
      return true;
    }

    return false;
  },
  showEntitlementTable: function(result) {
    if (ACC.orderReason.isCourageAllowed() === true) {
      if (result.allpartsnotcovered === 'true') {
        ACC.orderReason.scrollToResult('entitlementByIp', false);
      } else if (result.coveragedetails) {
        ACC.orderReason.entitlementResult(result.coveragedetails, 'entitlementByIp');
        ACC.orderReason.scrollToResult('entitlementByIp', true);
      }
    }
  },
  checkIpLookup: function(isValid, dataObj) {
    var ajaxPath = $('.ph-iplookup_url').val(),
        successMsgCls = '.ph-successmessage',
        errorIp = '.ph-ipLuperrormessage';


    var orderReasontype = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    if (orderReasontype === 'equipmentwarranty') {
      successMsgCls = '.ph-equip-successmessage';
      errorIp = '.ph-ipLuperrormessageEquip';
    } else if (orderReasontype === 'tibaservicecontract') {
      successMsgCls = '.ph-tiba-successmessage';
      errorIp = '.ph-ipLuperrormessageTiba';
    }

    $(ACC.orderReason.entitlementError).addClass('hidden');
    $(ACC.orderReason.spinnerOrder).removeClass(ACC.orderReason.displayblock).addClass(ACC.orderReason.displaynone);

    if (isValid) {
      $(ACC.orderReason.defaultloader).show();
      $.ajax({
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        url: ajaxPath,
        type: 'POST',
        data: JSON.stringify(dataObj),
        dataType: 'json',
        success: function(result) {
          $(ACC.orderReason.defaultloader).hide();
          ACC.orderReason.showEntitlementTable(result);

          if (ACC.orderReason.$isssoLogin === 'false') {
            var iserror = result.errorMessage !== null && result.errorMessager !== '';

            if ((result.installedProductNumber === null || result.installedProductNumber === '') && iserror) {
              $(ACC.orderReason.equipmentiPserialnumberIds).removeAttr('readonly');
              ACC.orderReason.ipLookuperrorHandler(errorIp, result.errorMessage);
            } else if (result.installedProductNumber) {
              $(ACC.orderReason.equipmentiPserialnumberIds).val(result.installedProductNumber).attr('readonly', 'readonly');
              $('#systemnumber').val(result.serialNo);
              $('#systemdescription').val(result.productDescription);
              $('#sixnc').val(result.productCode);
              $(successMsgCls).removeClass('hidden');
            }
          }
        },
        error: function() {
          $(ACC.orderReason.defaultloader).hide();
          $(errorIp).html($(errorIp).attr('responseError'));
          $(errorIp).removeClass('hidden');
        }
      });
    }
  },
  checkIpLookupclearFlag: function() {
    ACC.orderReason.clearErrorFlag($(ACC.orderReason.sixnc));
    ACC.orderReason.clearErrorFlag($(ACC.orderReason.systemnumber));
    ACC.orderReason.clearErrorFlag($(ACC.orderReason.systemdescription));
  },
  checkEntiSenarios: function(isValid, dataObj) {
    if (ACC.orderReason.validInputWithProperValue($(ACC.orderReason.iPserialnumber)) || $.trim($(ACC.orderReason.systemnumber).val()) !== '') {
      dataObj.iPserialnumber = $.trim($(ACC.orderReason.iPserialnumber).val());
      ACC.orderReason.checkIpLookup(isValid, dataObj);
    } else if (ACC.orderReason.validInputWithProperValue($(ACC.orderReason.equipmentserialnumberId)) || $.trim($(ACC.orderReason.systemnumber).val()) !== '') {
      dataObj.iPserialnumber = $.trim($(ACC.orderReason.equipmentserialnumberId).val());
      ACC.orderReason.checkIpLookup(isValid, dataObj);
    } else {
      ACC.orderReason.setErrorFlag($(ACC.orderReason.systemnumber));
    }
  },
  checkIpLookupEntiSenarios: function(isValid, dataObj) {
    if ($.trim($(ACC.orderReason.iPserialnumber).val()) !== '' || $.trim($(ACC.orderReason.equipmentserialnumberId).val()) !== '') {
      ACC.orderReason.checkEntiSenarios(isValid, dataObj);
    } else if ($.trim($(ACC.orderReason.systemnumber).val()) !== '' && $.trim($(ACC.orderReason.sixnc).val()) !== '') {
      dataObj.systemnumber = $.trim($(ACC.orderReason.systemnumber).val());
      dataObj.sixnc = $.trim($(ACC.orderReason.sixnc).val());
      ACC.orderReason.checkIpLookup(isValid, dataObj);
    } else if ($.trim($(ACC.orderReason.systemnumber).val()) !== '' && $.trim($(ACC.orderReason.systemdescription).val()) !== '') {
      dataObj.systemnumber = $.trim($(ACC.orderReason.systemnumber).val());
      dataObj.systemdescription = $.trim($(ACC.orderReason.systemdescription).val());
      ACC.orderReason.checkIpLookup(isValid, dataObj);
    } else if ($.trim($(ACC.orderReason.systemnumber).val()) !== '' && $.trim($(ACC.orderReason.sixnc).val()) === '' && $.trim($(ACC.orderReason.systemdescription).val()) === '') {
      dataObj.systemnumber = $.trim($(ACC.orderReason.systemnumber).val());
      ACC.orderReason.checkIpLookup(isValid, dataObj);
    }
  },

  checkIpLookupnewSenarios: function() {
    ACC.orderReason.checkIpLookupclearFlag();

    var dataObj = {},
        isValid = true,
        entitlementcall = false,
        orderReasontype = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase(),
        coverageOrderReason = $('.ph-coverageOrderReason').html(),
        coverageOrderReasonmyArray = [];

    function entitlementCheck(item) {
      if (item === orderReasontype) {
        dataObj.orderreasontype = orderReasontype;
        entitlementcall = true;
      }
    }

    if (orderReasontype === 'commercialdefoa' || orderReasontype === 'billed') {
      dataObj.orderreasontype = orderReasontype;
      entitlementcall = true;
    }

    coverageOrderReasonmyArray = coverageOrderReason.split(',');
    coverageOrderReasonmyArray.forEach(entitlementCheck);

    if (entitlementcall === true) {
      if (ACC.orderReason.$isssoLogin === 'true' && orderReasontype !== 'commercialdefoa' && orderReasontype !== 'billed') {
        ACC.orderReason.checkIpLookup(isValid, dataObj);
      } else if (ACC.orderReason.$isssoLogin !== 'true') {
        ACC.orderReason.checkIpLookupEntiSenarios(isValid, dataObj);
      }
    }
  },
  noOfWordsVal: function(inputVal, wordCount) {
    var spaceChar = ' ',
        flag = false,
        valArr = inputVal.replace(/\s\s+/g, spaceChar).split(spaceChar),
        ipRegex = /^[A-Za-z0-9]+$/;

    if (valArr.length <= wordCount) {
      flag = true;
      $.each(valArr, function(key, value) {
        if (flag) {
          flag = ipRegex.test(value);
        }
      });
    }

    return flag;
  },
  sysNumBlurVal: function(ele) {
    var $this = $(ele),
        trimVal = $.trim($this.val());

    if (ACC.orderReason.showCoverageDetails === 'true' && $(ACC.orderReason.iPserialnumber).val() !== '' &&
    $(ACC.orderReason.iPserialnumber).val() !== '0') {
      ACC.orderReason.clearErrorFlag($this);
    } else if (trimVal === '') {
      ACC.orderReason.setErrorFlag($this);
      $(ACC.orderReason.equipmentiPserialnumberIds).val('0').removeAttr('readonly');
    } else {
      ACC.orderReason.clearErrorFlag($this);
    }
  },

  sysDesErrFlag: function(ele) {
    ACC.orderReason.setErrorFlag($(ele));
    $(ACC.orderReason.equipmentiPserialnumberIds).removeAttr('readonly');
  },
  isEmbargoCountryCheck: function(orderReasontype) {
    var errorIp = '.ph-ipLuperrormessage',
        errorContractAttr = 'embargoMsg';

    if (orderReasontype === 'equipmentwarranty') {
      errorIp = '.ph-ipLuperrormessageEquip';
      errorContractAttr = 'equipEmbargoMsg';
    } else if (orderReasontype === 'tibaservicecontract') {
      errorIp = '.ph-ipLuperrormessageTiba';
      errorContractAttr = 'tibaEmbargoMsg';
    }

    $('.ph-ipLuperrormessage,.ph-ipLuperrormessageEquip,.ph-ipLuperrormessageTiba')
      .addClass('hidden').removeClass('form_field_error');

    if ($.trim($('.ph-isEmbargoCountry').html()) === 'true') {
      $('#tofetchContract, #tofetchIPSerial').hide();
      $(errorIp).html($(errorIp).attr('iplookupembargo'));
      $(errorIp).removeClass('hidden').addClass('form_field_error');
      $(ACC.orderReason.errorContract).html($(ACC.orderReason.errorContract).attr(errorContractAttr));
      $(ACC.orderReason.errorContract).removeClass('hidden');
    }
  },
  checkorderreason: function() {
    var orderReasontype = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    if (orderReasontype === 'commercialdefoa' || orderReasontype === 'billed') {
      $('.ph-ipcheck').removeClass('hidden');
      $('.ph-entitlementmsg').addClass('hidden');
    } else {
      $('.ph-ipcheck').addClass('hidden');
      $('.ph-entitlementmsg').removeClass('hidden');
    }

    ACC.orderReason.isEmbargoCountryCheck(orderReasontype);
    ACC.orderReason.dynamicButtonLabel();
  },
  onDocumentReadyFunction: function() {
    $(ACC.orderReason.systemdescription).on('blur', function() {
      var $this = $(this),
          thisVal = $.trim($this.val());

      ACC.orderReason.clearErrorFlag($this);

      if (thisVal === '') {
        $('#sixnc').removeAttr('disabled');
        ACC.orderReason.toggleIpLookupbuttonLabel('ipandentitlement');
      } else if (thisVal.length < 4 || !ACC.orderReason.noOfWordsVal(thisVal, 3)) {
        ACC.orderReason.sysDesErrFlag(this);
        ACC.orderReason.toggleIpLookupbuttonLabel('entitlement');
      }
    });
    ACC.orderReason.iplookupfeaturetoogleReset();
    ACC.orderReason.orderReasonDropdownChange();
    ACC.orderReason.mobileViewOrderReason();
    $(ACC.orderReason.sixnc).focus(function() {
      $('#systemdescription').attr('disabled', 'disabled');
      ACC.orderReason.clearErrorFlag($('#systemdescription'));
      ACC.orderReason.serailnumberfocus();
    });
    ACC.orderReason.checkorderreason();

    $(ACC.orderReason.iPserialnumber).on('focus', function() {
      ACC.orderReason.ipserailfocus();
    });
    $(ACC.orderReason.equipmentserialnumberId).on('focus', function() {
      ACC.orderReason.ipserailfocus();
    });
    $(ACC.orderReason.systemnumber).focus(function() {
      ACC.orderReason.serailnumberfocus();
    });
    $(ACC.orderReason.systemnumber).on('blur', function() {
      ACC.orderReason.sysNumBlurVal(this);
    });
  },
  sixncBlurVal: function(ele) {
    var $this = $(ele),
        trimVal = $.trim($this.val()),
        ipRegex = ACC.orderReason.sixncReg;


    if (trimVal === '' || !ipRegex.test(trimVal)) {
      ACC.orderReason.setErrorFlag($this);
    } else {
      ACC.orderReason.clearErrorFlag($this);
    }

    if (trimVal === '') {
      ACC.orderReason.clearErrorFlag($this);
      $('#systemdescription').removeAttr('disabled');
      ACC.orderReason.toggleIpLookupbuttonLabel('ipandentitlement');
    } else {
      ACC.orderReason.toggleIpLookupbuttonLabel('entitlement');
    }
  },
  nullCheck: function(inputValue, returnForNull) {
    if (inputValue) {
      return inputValue;
    }

    if (returnForNull) {
      return returnForNull;
    }

    return '';
  },
  servicePlanDescResponse: function(responseData) {
    var responseJson = ACC.orderReason.nullCheck(responseData),
        listItemRows = '';

    if (typeof responseData !== 'object') {
      responseJson = JSON.parse(responseData);
    }

    if ((responseJson[0] && responseJson[0].errorMessage) || responseJson === '') {
      responseJson = [];
    }

    $.each(responseJson, function(indexNum, responseItem) {
      listItemRows = listItemRows + '<tr class="ph-customertr">' +
      '<td class="p ph-border-0"><label class="ph-radiocontainer ph-col-2 ph-float-left">' +
      '<input type="radio" id="servicecontract_' + indexNum +
      '" class="ph-customerradio serviceplancontract__radio" value="' + responseItem.contractNumber + '" name="servicecontractnum">' +
      '<span class="ph-checkmark"></span></label></td>' +
      '<td>' + ACC.orderReason.nullCheck(responseItem.contractNumber, '-') + '</td>' +
      '<td>' + ACC.orderReason.nullCheck(responseItem.servicePlandesc, '-') + '</td>' +
      '<td>' + ACC.orderReason.nullCheck(responseItem.sapContractnum, '-') + '</td>' +
      '<td>' + ACC.orderReason.nullCheck(responseItem.lineNumber, '-') + '</td>' +
      '</tr>';
    });

    if (listItemRows !== '') {
      ACC.orderReason.servicePlanDescResponseAdd(listItemRows, responseJson);
    }
  },
  servicePlanDescResponseAdd: function(listItemRows, responseJson) {
    var $serviceplancontractHeaders = $('.serviceplancontract_headers'),
        serviceplancontractContainer = '.ph-serviceplancontract__container';
    var tableData = '<table class="ph-table ph-border ph-mb-0">' +
      '<thead class="ph-tablehead"><tr>' +
      '<th>' + $serviceplancontractHeaders.attr('data-selectLabel') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-contractNumber') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-servicePlandesc') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-sapContractnum') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-lineNumber') + '</th>' +
      '</tr></thead>';

    tableData = tableData + '<tbody class="ph-tablebody">' + listItemRows + '</tbody></table>';
    $(serviceplancontractContainer).html(tableData).show();

    if (responseJson.length === 1) {
      $(serviceplancontractContainer).find(ACC.orderReason.spcontractRadio).prop('checked', true);
      $(ACC.orderReason.spcontractRadio).trigger('click');
      $(ACC.orderReason.successContract).html($(ACC.orderReason.successContract).attr('data-singleItem'));
    } else if (responseJson.length >= 1) {
      $(ACC.orderReason.successContract).html($(ACC.orderReason.successContract).attr('data-multipleItems'));
    }
  },
  dynamicButtonLabel: function() {
    if (ACC.orderReason.isCourageAllowed() === true) {
      $('.ph-contract_entitlement--btnlabel').html($('.ph-fetchcontractandentitlement').html());
    } else {
      $('.ph-contract_entitlement--btnlabel').html($('.ph-fetchcontractonly').html());
    }
  },
  getEntitlementbyContract: function(sapContractNum) {
    var ajaxPath = $('.ph-iplookup_url').val(),
        orderReasontype = $(ACC.orderReason.orderReasonId).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase(),
        dataObj = {
          orderreasontype: orderReasontype,
          sapContractNumber: sapContractNum
        };

    $(ACC.orderReason.defaultloader).show();
    $(ACC.orderReason.entitlementError).addClass('hidden');
    $.ajax({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      url: ajaxPath,
      type: 'POST',
      data: JSON.stringify(dataObj),
      dataType: 'json',
      success: function(result) {
        $(ACC.orderReason.defaultloader).hide();

        if (ACC.orderReason.showCoverageDetails === 'true') {
          if (result.allpartsnotcovered === 'true') {
            ACC.orderReason.scrollToResult('entitlementByContract', false);
          } else if (result.coveragedetails) {
            ACC.orderReason.entitlementResult(result.coveragedetails, 'entitlementByContract');
            ACC.orderReason.scrollToResult('entitlementByContract', true);
          }
        }
      },
      error: function() {
        $(ACC.orderReason.defaultloader).hide();
      }
    });
  },
  errorMessageHandler: function(errorContract, msgType) {
    switch (msgType) {
        case 'text.orderReasonPage.contractnumber.error':
          $(errorContract).html($(errorContract).attr('contractNumberError'));

          break;
        case 'text.contractlookup.responseerror':
          $(errorContract).html($(errorContract).attr('responseError'));

          break;
        case 'text.contractlookup.error':
          $(errorContract).html($(errorContract).attr('contractLookupError'));

          break;
        case 'text.contractlookup.connectTimeout':
          $(errorContract).html($(errorContract).attr('connectTimeout'));

          break;
        case 'text.contractlookup.socketTimeout':
          $(errorContract).html($(errorContract).attr('socketTimeout'));

          break;
        case 'text.contractlookup.interrupted':
          $(errorContract).html($(errorContract).attr('interrupted'));

          break;
        case 'text.contractlookup.resourceAcess':
          $(errorContract).html($(errorContract).attr('resourceAcess'));

          break;
        case 'text.contractlookup.noresults':
          $(errorContract).html($(errorContract).attr('noresults'));

          break;
        case 'validation.error':
          $(errorContract).html($(errorContract).attr('validationError'));

          break;
        default:
    }

    $(errorContract).removeClass('hidden');
    $('.ph-serviceplancontract__container').html('');
  },
  contractLookup: function() {
    var contractNumber = $(ACC.orderReason.contractNumber).val();

    $(ACC.orderReason.defaultloader).show();
    $.ajax({
      url: ACC.config.contextPath + '/orderReason/contractLookup.json',
      type: 'POST',
      data: {
        contractNumber: contractNumber
      },
      cache: true,
      success: function(result) {
        $(ACC.orderReason.defaultloader).hide();

        if (result && result[0]) {
          if (result[0].errorMessage === null) {
            ACC.orderReason.servicePlanDescResponse(result);
            $(ACC.orderReason.successContract).removeClass('hidden');
          } else {
            ACC.orderReason.errorMessageHandler(ACC.orderReason.errorContract, result[0].errorMessage);
          }
        } else {
          ACC.orderReason.errorMessageHandler(ACC.orderReason.errorContract, 'text.contractlookup.responseerror');
          $(ACC.orderReason.errorContract).removeClass('hidden');
        }
      },
      error: function() {
        $(ACC.orderReason.defaultloader).hide();
        $(ACC.orderReason.errorContract).html($(ACC.orderReason.errorContract).attr('responseError'));
        $(ACC.orderReason.errorContract).removeClass('hidden');
      }
    });
  },
  contractNoBlurVal: function(ele) {
    var ipRegex = /^[\d]{8,10}$/,
        $this = $(ele),
        trimVal = $.trim($this.val()),
        ipRegexOne = /^[CON]{3}[\d]{7}$/;

    $(ACC.orderReason.errorContract).addClass('hidden');
    $(ACC.orderReason.successContract).addClass('hidden');

    if (trimVal !== '' && (ipRegex.test(trimVal) || ipRegexOne.test(trimVal))) {
      ACC.orderReason.contractLookup();
    } else {
      $(ACC.orderReason.errorContract).removeClass('hidden');
      ACC.orderReason.errorMessageHandler(ACC.orderReason.errorContract, 'validation.error');
    }
  },
  serialNumZeroOnLoad: function() {
    if ($(ACC.orderReason.equipmentserialnumberId).val() === '') {
      $(ACC.orderReason.equipmentserialnumberId).val('0');
    }

    if ($(ACC.orderReason.iPserialnumber).val() === '') {
      $(ACC.orderReason.iPserialnumber).val('0');
    }

    if ($('#validEquipmentNumber').val() === '') {
      $('#validEquipmentNumber').val('0');
    }
  },

  ssoflowImplementation: function() {
    $('.ph-SSOsuccessmessage').removeClass('hidden');
    $('#incidentNumber,#equipmentserialnumber,#iPserialnumber').addClass('disable ph-disable').attr('readonly', 'readonly');
    $('#sysnumber,#systemdesc,#sixn,#tofetchIPSerial,#contractNumber').parent('section').addClass('hidden');
    $('.ph-iplookup_table table').css('min-width', '0px');
    $('#contractNumber,#tofetchIPSerial').css('display', 'none');
  },
  mobileViewOrderReason: function() {
    var mobWidth = $(window).width();

    if (mobWidth <= 768) {
      $('.ph-iplookup_table hr').addClass('hidden');
      $('.ph-iplookup_table section').removeClass('ph-border-topNone');
      $('.ph-installedProduct-Section div').removeClass('ph-border');
      $('#forEquipmentSection').removeClass('ph-border ph-p-1 ph-mt-1 ');
      $('#forEquipmentSection p').addClass('ph-mb-3');
      $('#contractNumber').removeClass('ph-border ph-p-1 ph-mt-1 ph-mb-1');
      $('#contractNumber').addClass('ph-border-bottom ph-mb-3');
      $('#tofetchIPSerial, #tofetchContract').addClass('ph-mb-3');
      $('.ph-incidentP').addClass('ph-pr-3');
      $('.ph-contractBorder').removeClass('hidden');
      $('.ph-ipMobile').addClass('ph-pt-1 ph-pb-1');
      $('.ph-ipMobile').removeClass('ph-pl-1 ph-p-1');
      $('.ph-ordersubnitbtn').removeClass('ph-m-1');
      $('.ph-ipPara').removeClass('ph-p-1');
      $('.ph-serviceplancontract__container table').removeClass('ph-mb-0');
      $('.ph-serviceplancontract__container table').addClass('ph-mb-3');
      $('.ph-incidentP').removeClass('ph-mt-1');
      ACC.orderReason.mobileViewOrderReasonnew();
    }
  },
  mobileViewOrderReasonnew: function() {
    $('.ph-incidentP').parent().removeClass('ph-mt-1');
    $('.ph-material_code,.ph-select_checkbox').addClass('ph-p-0 ph-mb-3');
    $('.ph-fcoitemrow').removeClass('ph-d-flex');
    $('.ph-material_code,.ph-select_checkbox').addClass('ph-p-0 ph-mb-3');
    $('.ph-fcoitemrow').removeClass('ph-mt-1');
  },
  entitlementResult: function(responseData, entitlementBy) {
    var responseJson = ACC.orderReason.nullCheck(responseData),
        listItemRows = '',
        noEntitlementMsg = $.trim($('.ph-noEntitlementMsg').html());

    if (typeof responseData !== 'object') {
      responseJson = JSON.parse(responseData);
    }

    if ((responseJson[0] && responseJson[0].errorMessage) || responseJson === '') {
      responseJson = [];
    }

    if (responseJson.length > 0) {
      $.each(responseJson, function(_indexNum, responseItem) {
        if (responseItem.coveredby) {
          listItemRows = listItemRows + '<tr class="ph-border-bottom">';
        } else {
          listItemRows = listItemRows + '<tr class="ph-border-bottom ph-configcolor">';
        }

        listItemRows = listItemRows + '<td>' + ACC.orderReason.nullCheck(responseItem.partnumber, '-') + '</td>' +
    '<td>' + ACC.orderReason.nullCheck(responseItem.coveredby, noEntitlementMsg) + '</td>' +
    '<td>' + ACC.orderReason.nullCheck(responseItem.coverageid, noEntitlementMsg) + '</td>' +
    '<td>' + ACC.orderReason.nullCheck(responseItem.sapcontract, '-') + '</td>' +
    '<td>' + ACC.orderReason.nullCheck(responseItem.sapcontractline, '-') + '</td>' +
    '</tr>';
      });
    }


    if (listItemRows !== '') {
      ACC.orderReason.entitlementResultResponseAdd(listItemRows, entitlementBy);
    }
  },
  entitlementResultResponseAdd: function(listItemRows, entitlementBy) {
    var $serviceplancontractHeaders = $('.entitlementResult'),
        entitlementContainer = '.ph-entitlement__container';
    var tableData = '<table class="ph-table ph-border ph-mb-0">' +
      '<thead class="ph-tablehead"><tr>' +
      '<th>' + $serviceplancontractHeaders.attr('data-partnumber') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-coveredby') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-coverageid') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-sapcontract') + '</th>' +
      '<th>' + $serviceplancontractHeaders.attr('data-sapcontractline') + '</th>' +
      '</tr></thead>';

    tableData = tableData + '<tbody class="ph-tablebody">' + listItemRows + '</tbody></table>';
    $('.ph-' + entitlementBy).find(entitlementContainer).html(tableData).show();
    $(ACC.orderReason.entitlementbody + '.ph-' + entitlementBy).removeClass('hidden');
  },
  scrollToResult: function(entitlementBy, resultStatus) {
    var $entitlementResultArea = $(ACC.orderReason.entitlementbody + '.ph-' + entitlementBy);

    if (resultStatus === false) {
      $entitlementResultArea = $(ACC.orderReason.entitlementError + '.ph-' + entitlementBy);
      $entitlementResultArea.removeClass('hidden');
    }

    if ($entitlementResultArea.length > 0) {
      $('html,body').animate({
        scrollTop: $entitlementResultArea.offset().top
      }, 'slow');
    }
  },
  scrollTillError: function() {
    var $errorFld = $('.form_field_error :first');

    if ($errorFld.length > 0) {
      $('html,body').animate({
        scrollTop: $errorFld.offset().top
      }, 'slow');
    }
  },
  ipBlurVal: function(ele) {
    var $this = $(ele),
        trimVal = $.trim($this.val());

    if ($.trim($(ACC.orderReason.systemnumber).val()) !== '') {
      $(ACC.orderReason.equipmentserialnumberId).val('');
      $(ACC.orderReason.iPserialnumber).val('');
      ACC.orderReason.toggleIpLookupbuttonLabel('ipandentitlement');
    } else if (trimVal === '') {
      ACC.orderReason.toggleIpLookupbuttonLabel('ipandentitlement');
    } else {
      ACC.orderReason.toggleIpLookupbuttonLabel('entitlement');
    }
  },
  ipserailfocus: function() {
    ACC.orderReason.toggleIpLookupbuttonLabel('entitlement');
  },
  serailnumberfocus: function() {
    ACC.orderReason.toggleIpLookupbuttonLabel('ipandentitlement');
  },
  validInputWithProperValue: function($field) {
    return $field.is(':visible') &&
    $.trim($field.val()) !== '' &&
    $field.val() !== '0';
  },
  blurEventsOnIpFetchButton: function() {
    if (ACC.orderReason.showCoverageDetails === 'true' &&
      ACC.orderReason.validInputWithProperValue($(ACC.orderReason.iPserialnumber))) {
      $(ACC.orderReason.iPserialnumber).trigger('blur');
      ACC.orderReason.clearErrorFlag($(ACC.orderReason.systemnumber));
    } else if (ACC.orderReason.showCoverageDetails === 'true' &&
      ACC.orderReason.validInputWithProperValue($(ACC.orderReason.equipmentserialnumberId))) {
      $(ACC.orderReason.equipmentserialnumberId).trigger('blur');
      ACC.orderReason.clearErrorFlag($(ACC.orderReason.systemnumber));
    } else {
      $(ACC.orderReason.systemnumber).trigger('blur');
      $(ACC.orderReason.sixnc).trigger('blur');
      $(ACC.orderReason.systemdescription).trigger('blur');
      $(ACC.orderReason.iPserialnumber).trigger('blur');
      $(ACC.orderReason.equipmentserialnumberId).trigger('blur');
    }
  },
  toggleIpLookupbuttonLabel: function(tobeShown) {
    if (tobeShown === 'entitlement') {
      $(ACC.orderReason.entitlement).removeClass('hidden');
      $(ACC.orderReason.ipandentitlement).addClass('hidden');
    } else {
      $(ACC.orderReason.entitlement).addClass('hidden');
      $(ACC.orderReason.ipandentitlement).removeClass('hidden');
    }
  },
  doSelectBoxRefresh: function() {
    if ($('.ph-orderreason-form').find('a.selectBox-dropdown').length > 0) {
      $(ACC.orderReason.orderReasonId).selectBox('refresh');
    }
  },
  afterCompletePageLoad: function() {
    var $orderReasonBackendValues = $('#orderReasonBackendValues'),
        orderReasonValue = $orderReasonBackendValues.attr('data-ordertype'),
        daysVal = $orderReasonBackendValues.attr('data-daysValue'),
        disableVal = $('#disableItems').attr('data-readonly'),
        disableTarget = $('#disableItems').attr('data-target'),
        orderReasonArray = ACC.orderReason.getOrderReasonArray();

    if (orderReasonValue) {
      var orderReasonSmall = orderReasonValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

      if ($.inArray(orderReasonSmall, orderReasonArray) !== -1) {
        var defaultValue = $(ACC.orderReason.orderReasonId).find('[data-smallValue="' + orderReasonSmall + '"]').val();

        $(ACC.orderReason.orderReasonId).val(defaultValue);
        ACC.orderReason.doSelectBoxRefresh();
        ACC.orderReason.orderReasonDropdownChange();

        if (orderReasonSmall === 'toolrental') {
          $('#numberofdays').val(daysVal);
          ACC.orderReason.daysDropdownChange();
        }
      }
    }

    if (disableVal === 'true') {
      $.each(disableTarget.split(','), function(k, v) {
        $('#' + v).prop('readonly', true);
      });
    }

    ACC.orderReason.uploadedFileName();
    ACC.orderReason.serialNumZeroOnLoad();
    ACC.orderReason.orderReasonDropdownChange();
    ACC.orderReason.mobileViewOrderReason();
    $(ACC.orderReason.orderReasonId).trigger('change');
    ACC.orderReason.toggleIpLookupbuttonLabel('ipandentitlement');
    $(ACC.orderReason.spinnerOrder).removeClass(ACC.orderReason.displayblock).addClass(ACC.orderReason.displaynone);
  }
};


$(document).ready(function() {
  if ($(ACC.orderReason.orderreasonpage).length > 0 && $('.enableNewOrderReason').text() !== 'true') {
    ACC.orderReason.bindAll();
    ACC.orderReason.mobileViewOrderReason();

    // Date picker code
    if ($('#invoicedate').length > 0) {
      ACC.datePicker.datePickerInit($('#invoicedate'));
    }

    $(ACC.orderReason.sixnc).on('blur', function() {
      ACC.orderReason.ipBlurVal(this);
    });

    $(ACC.orderReason.equipmentserialnumberId).on('blur', function() {
      ACC.orderReason.ipBlurVal(this);
    });

    $(ACC.orderReason.iPserialnumber).on('blur', function() {
      ACC.orderReason.ipBlurVal(this);
    });
    $(ACC.orderReason.systemnumber).on('blur', function() {
      ACC.orderReason.sysNumBlurVal(this);
    });

    $('#tofetchContract').on('click', function() {
      var $contractContainer = $(ACC.orderReason.contractNumber);

      $(ACC.orderReason.entitlementbody).addClass('hidden');
      $(ACC.orderReason.entitlementError).addClass('hidden');
      ACC.orderReason.contractNoBlurVal($contractContainer);
      ACC.orderReason.mobileViewOrderReason();
    });

    $(document).on('click', ACC.orderReason.spcontractRadio, function() {
      $(ACC.orderReason.contractNumber).val($(this).val());

      if (ACC.orderReason.showCoverageDetails === 'true') {
        ACC.orderReason.getEntitlementbyContract($(this).val());
      }
    });

    $(document).on('click', '#tofetchIPSerial', function() {
      $('.ph-ipLuperrormessage,.ph-ipLuperrormessageEquip,.ph-ipLuperrormessageTiba').removeClass('form_field_error');
      $('.ph-successmessage, .ph-tiba-successmessage, .ph-equip-successmessage').addClass('hidden');
      $('.ph-ipLuperrormessage, .ph-ipLuperrormessageTiba, .ph-ipLuperrormessageEquip').addClass('hidden');

      ACC.orderReason.blurEventsOnIpFetchButton();

      $(ACC.orderReason.entitlementbody).addClass('hidden');
      $(ACC.orderReason.entitlementError).addClass('hidden');

      if ($(ACC.orderReason.iPsection).find('.form_field_error').length === 0) {
        ACC.orderReason.checkIpLookupnewSenarios();
      }

      ACC.orderReason.scrollTillError();
    });

    ACC.orderReason.onDocumentReadyFunction();


    $(ACC.orderReason.systemdescription).focus(function() {
      $('#sixnc').attr('disabled', 'disabled');
      ACC.orderReason.serailnumberfocus();
    });

    $(ACC.orderReason.entitlementbody).addClass('hidden');
    $(ACC.orderReason.entitlementError).addClass('hidden');
  }
});

if ($(ACC.orderReason.orderreasonpage).length > 0 && $('.enableNewOrderReason').text() !== 'true') {
  $(window).on('load', function() {
    ACC.orderReason.afterCompletePageLoad();

    if (ACC.orderReason.$isssoLogin === 'true') {
      ACC.orderReason.ssoflowImplementation();
      ACC.orderReason.checkIpLookupnewSenarios();
    }
  });
}
